import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, XCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { fmtDate, fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { ReasonDialog } from "@/components/LicenseDialogs";

export function RenewalRequests({ onForwarded }) {
  const [rows, setRows] = useState([]);
  const [reject, setReject] = useState(null);
  const load = () => api.get("/renewals").then((r) => setRows(r.data.filter((x) => x.status === "inviata"))).catch(() => {});
  useEffect(() => { load(); }, []);
  const forward = async (r) => {
    try {
      await api.post(`/renewals/${r.id}/forward`);
      toast.success("Rinnovo inoltrato alla sede nazionale");
      load();
      onForwarded?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="mb-10" data-testid="renewal-requests">
      <div className="mb-3 font-display text-lg font-semibold">Richieste di rinnovo dagli atleti <span className="text-slate-400">({rows.length})</span></div>
      {rows.length === 0 ? <div className="text-sm text-slate-500">Nessuna richiesta di rinnovo da gestire.</div> : (
        <div className="grid gap-3 md:grid-cols-2">
          {rows.map((r) => (
            <div key={r.id} className="card-surface p-5" data-testid={`renewal-card-${r.id}`}>
              <div className="font-display text-lg font-semibold">{r.athlete_name}</div>
              <div className="font-mono text-xs text-slate-500">Licenza {r.license_number} · scadenza {fmtDate(r.expiry_date)}</div>
              <div className="mt-1 text-xs text-slate-500">Richiesta il {fmtDateTime(r.created_at)}</div>
              {r.note && <div className="mt-2 rounded-lg bg-slate-50 p-2 text-sm text-slate-600">{r.note}</div>}
              <div className="mt-4 flex gap-2">
                <Button onClick={() => forward(r)} className="bg-[#0F2042] hover:bg-[#1E3A8A]" data-testid={`renewal-forward-btn-${r.id}`}><Send className="mr-2 h-4 w-4" />Inoltra alla sede</Button>
                <Button variant="outline" onClick={() => setReject(r)} className="border-red-200 text-red-700 hover:bg-red-50" data-testid={`renewal-reject-btn-${r.id}`}><XCircle className="mr-2 h-4 w-4" />Respingi</Button>
              </div>
            </div>
          ))}
        </div>
      )}
      <ReasonDialog open={!!reject} onOpenChange={(v) => !v && setReject(null)} title="Respingi richiesta di rinnovo" confirmLabel="Respingi" danger
        onConfirm={async (reason) => { await api.post(`/renewals/${reject.id}/reject`, { reason }); toast.success("Richiesta respinta"); load(); }} />
    </div>
  );
}
